
import { getUrlApi } from '../utilities/util';
import ApiHandler from './ApiHandlers/ApiHandler'; 

export const baseURL = String(getUrlApi()); 

export default class EventApi { 
    static async GetAllEvents(): Promise<any> {
        return ApiHandler(baseURL).get("/event/getallevents");
    }; 

    static async GetEventsByDeviceId(deviceId: number, date: Date): Promise<any> {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear());
        const initialDate = `${year}-${month}-${day} 00:00:00`;
        const finalDate = `${year}-${month}-${day} 23:59:59`; 
        return ApiHandler(baseURL).get("/event/geteventsbydeviceid?deviceId=" + deviceId + "&startDate=" + initialDate + "&endDate=" + finalDate);
    }; 

    static async GetEventsByStationId(deviceId: number): Promise<any> {
        return ApiHandler(baseURL).get("/event/geteventsbystationid?deviceId=" + deviceId);
    }; 
    
    static async CreateEvent(stationId: string, deviceId: number, status: boolean, accuracy: number): Promise<any> { 
        return ApiHandler(baseURL).post("/event/eventcreate", { stationId, deviceId, status, accuracy })
    }
}